import { useContext } from 'react';
import { TeamsUserContext, TeamsUserContextType } from 'src/contexts/TeamsUserContext';

import { ERROR_MESSAGES } from 'src/utils/constants';

export const useTeamsUser = (): TeamsUserContextType => {
  const context = useContext(TeamsUserContext);
  if (!context) {
    throw new Error(ERROR_MESSAGES.cannotUseuseTeamsUser);
  }
  return context;
};
